import React from "react"

import { withApp } from "@/components/App"
import OperatorRegistrationForm from "../features/operator_registration/components/OperatorRegistrationForm"

const App = (props): JSX.Element => <OperatorRegistrationForm form={props.form} />

export default withApp(App)
